module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr. Amos Olufemi Adeleye.d82cb6f2.jpeg";